import { useEffect, useState } from 'react';
import './TeacherContent.css';
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { onUpdateFilterData } from '../../../exportFunctions/standardExportFunctions';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
// Components
import IonicPageWrapper from '../../../components/IonicPageWrapper/IonicPageWrapper';
import StandardButton from '../../../components/StandardButton/StandardButton';

function TeacherContent() {
    const history = useHistory()
    const { pathname, state } = useLocation();
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(true)
    const [cardData, setCardData] = useState({})
    const [mappedCardData, setMappedCardData] = useState([])

    const [cardPushState, setCardPushState] = useState({});

    useEffect(() => {
        if (pathname == '/teacher/content') {
            fetchIDcardByClassID()
            fetchMappedData()
        }
    }, [pathname])

    useEffect(() => {
        if (Object.keys(cardData)?.length > 0) onUpdateBtnStatus();
    }, [mappedCardData, cardData])

    const onUpdate = () => {
        if (cardPushState?.verified === 1) return;

        if (cardPushState?.cardUpdate) {
            history.push("/update", { ...cardPushState, cData: { ...cardPushState?.cData, id: cardPushState?.cData?.id || cardPushState?.cData?.icard_id } })
        } else {
            history.push("/update", { cData: cardData, cardUpdate: false, teacher_idCreate: true, teacher_idCreate_userID: state?.userData?.id })
        }
    }

    const fetchIDcardByClassID = async () => {
        if (!state) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });

        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getidcardbyclassid`, { class_id: state?.userData?.schoolid }) // Send school ID
            .then(res => {
                if (res.data.success) {
                    setCardData(res?.data?.data?.[0])
                } else {
                    enqueueSnackbar(res.data.message, { variant: 'error' });
                }
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
            })
    }

    const fetchMappedData = async () => {
        if (!state) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });
        console.log("getmapped_data_byuserid api is called", state?.userData?.id)
        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getmapped_data_byuserid`, { user_id: state?.userData?.id })
            .then(async res => {
                if (res.data.success) {
                    setMappedCardData(res.data.data)
                } else {
                    setMappedCardData(null)
                }
            })
            .catch(err => {
                console.log(err);
                enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
            })
    }

    const onUpdateBtnStatus = async () => { // value is the data comin from fetchMappedData()
        if (mappedCardData === null) return setCardPushState({ cardUpdate: false, verified: false }); // For Making New ID Card 

        const cardIndex = mappedCardData?.findIndex(data => data.id_card.icard_id === cardData?.id);

        if (cardIndex == -1) {
            // ID Card not found and making new one
            setCardPushState({ cardUpdate: false, verified: false });
        } else {
            // ID Card found and updating
            setCardPushState({
                cData: onUpdateFilterData(mappedCardData?.[cardIndex]?.id_card, mappedCardData?.[cardIndex]?.user_data[0]),
                cardUpdate: true,
                mapped_id: mappedCardData?.[cardIndex]?.user_data[0]?.mapped_id,
                after_update_push: '/teacher/home',
                verified: mappedCardData?.[cardIndex]?.user_data[0]?.is_verified,
            });
        }
    }

    return (
        <IonicPageWrapper headerTitle='Content' onBackClick={() => history.goBack()} >
            <div id="teacherContent">
                {loading ? <CircularProgress sx={{ color: '#003554', display: 'block', margin: 'auto' }} /> : (
                    <section className='teacherContent_cont' >
                        <div className="teacherContent_imgCont">
                            <img src={cardData?.document_path_front} />
                            {cardData?.type == 2 && <img src={cardData?.document_path_back} style={{ marginTop: 15 }} />}
                        </div>

                        <StandardButton onClick={onUpdate}
                            disabled={loading || cardPushState?.verified === 1}
                            label={cardPushState?.verified === 1 ? 'ID Verified' : cardPushState?.cardUpdate ? 'Update ID' : 'Create ID'}
                            bg={cardPushState?.verified === 1 ? 'rgb(3, 69, 3)' : '#006494'}
                        />
                    </section>
                )}
            </div>
        </IonicPageWrapper>
    )
}

export default TeacherContent